













































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import AddServicesToCartTrigger from './AddServicesToCartTrigger.coffee'

settings =
  name: 'AddServicesToCartTriggerModal'

  resources:
    vendor_listings:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings'
      infinityScroll: false
      fetch: false
      params:
        scope: 'active'
        limit: 1000

  vue:
    props: ['resourceComponent', 'resourceKey']

    components: {
      Modal,
      RequestButton,
      LoadingIndicator,
    }

    mixins: [AddServicesToCartTrigger.trigger()]

    computed:
      serviceTypes: ->
        other: 'Other'
        printing: 'Printing'
        shipping: 'Shipping'
        staffing: 'Staffing'
        custom_fabrication: 'Custom fabrication'
        redemption_scanning: 'Redemption program receipt scanning'
        digital_media: 'Digital Media'

      serviceGroups: ->
        groups = {}
        for serviceType, label of @serviceTypes
          groups[serviceType] = { label, vendorListings: [] }
        for vendorListing in (@vendor_listings || [])
          serviceType = vendorListing.professional_service_type
          groups[serviceType].vendorListings.push vendorListing
        for serviceType, group of groups
          if group.vendorListings.length is 0
            delete groups[serviceType]
            continue
          group.vendorListings.sort((a, b) => a.title.localeCompare(b.title))
        groups

    methods:
      modalData: ->
        vendor_listing_id: null

     watch:
      'modal.show': (value) ->
        if value
          @fetch 'vendor_listings'
        else
          @modal.data.vendor_listing_id = null

export default VueOptions.vue settings
